export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-ink px-6 text-center">
      <p className="mb-4 text-[10px] uppercase tracking-[0.3em] text-gold">
        Aureon Global Markets · Terminal Access
      </p>
      <h1 className="font-serif text-5xl font-light tracking-tighter text-white sm:text-6xl" data-testid="payment-cancel-title">
        Payment <span className="italic text-gold">cancelled.</span>
      </h1>
      <p className="mx-auto mt-6 max-w-md text-sm leading-relaxed text-white/50">
        Nothing was charged. The terminal will be here when you're ready.
      </p>
      <a
        data-testid="cancel-back-home-btn"
        href="/"
        className="mt-10 inline-flex items-center gap-3 rounded-full border border-gold/40 px-10 py-5 text-xs uppercase tracking-[0.2em] text-gold transition-colors duration-300 hover:bg-gold hover:text-ink"
      >
        Back to Aureon
      </a>
    </div>
  );
}
